<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="36">
          <a-col :span="5">
            <a-form-item label="库位">
              <a-input v-model="orderNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="类型">
              <a-select :placeholder="$t('business.placeholder.pleaseSelect')" default-value="0" v-model="status">
                <a-select-option value="0">普通库位</a-select-option>
                <a-select-option value="1">特殊库位</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="4 || 24" :sm="24">
            <span :style="{ float: 'right', overflow: 'hidden' } || {} " class="table-page-search-submitButtons">
              <a-button @click="querySale" type="primary">{{ $t('button.query') }}</a-button>
              <a-button @click="clearParam" style="margin-left: 8px">{{ $t('button.reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      :dataSource="data"
      :loading="loading"
      :pagination="false"
      bordered
      size="small">
      <a-table-column :title="$t('business.label.index')" dataIndex="key" width="50px">
        <span slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
      </a-table-column>
      <a-table-column v-if="show" :title="$t('business.label.config')" dataIndex="id"></a-table-column>
      <a-table-column dataIndex="no" title="货位#*" width="150px">
        <template slot-scope="text,record">
          <a-input
            placeholder="货位"
            style="width: 100%"
            v-model="record.no">
          </a-input>
        </template>
      </a-table-column>
      <a-table-column dataIndex="shelves" title="货架#" width="150px">
        <template slot-scope="text,record">
          <a-input
            placeholder="货架"
            style="width: 100%"
            v-model="record.shelves">
          </a-input>
        </template>
      </a-table-column>
      <a-table-column dataIndex="type" title="类型*" width="150px">
        <template slot-scope="text,record">
          <a-input
            placeholder="类型"
            style="width: 100%"
            v-model="record.type">
          </a-input>
        </template>
      </a-table-column>
      <a-table-column dataIndex="xyz" title="坐标*" width="150px">
        <template slot-scope="text,record">
          <a-input
            placeholder="坐标"
            style="width: 100%"
            v-model="record.xyz">
          </a-input>
        </template>
      </a-table-column>
      <a-table-column dataIndex="available" title="是否启用" width="150px">
        <template slot-scope="text, record">
          <a-checkbox
            :defaultChecked="true"
            @change="e => handleSign(e.target.checked, record.id,'appendageSign')"
          />
        </template>
      </a-table-column>
      <a-table-column :title="$t('business.label.operate')" dataIndex="action" width="150px">
        <template slot-scope="text, record">
          <template>
            <a @click="remove(record)">{{ $t('button.delete') }}</a>
          </template>
        </template>
      </a-table-column>
    </a-table>
    <div>
      <a-button @click="newMember" icon="plus" style="width: 100%; margin-top: 1px;margin-bottom: 5px" type="dashed">
        新增货位
      </a-button>
    </div>
    <footer-tool-bar
      :style="{ width: isSideMenu() && isDesktop() ? `calc(100% - ${sidebarOpened ? 256 : 80}px)` : '100%'}">
      <a-button :loading="loading" @click="newOrder" type="primary">{{ $t('button.refresh') }}
      </a-button>
      <a-divider type="vertical"/>
      <a-button :loading="loading" @click="handleCall" type="primary">{{ $t('button.save') }}</a-button>
    </footer-tool-bar>
  </a-card>
</template>

<script>
import { mixin, mixinDevice } from '@/utils/mixin'
import FooterToolBar from '@/components/FooterToolbar'
import moment from 'moment'
import { validateFields } from '@/utils/field-check'
import { deleteOne } from '@/api/Api'

export default {
    name: 'Location',
    mixins: [mixin, mixinDevice],
    components: {
      FooterToolBar
    },
    data: function () {
      return {
        pagination: {
          pageSize: 10,
          current: 1,
          defaultPageSize: 10,
          showQuickJumper: true,
          // showTotal: total => `共 ${total} 条数据`,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '15', '20'],
          onShowSizeChange: (current, pageSize) => {
            this.pageSize = pageSize, this.currentPageSize = pageSize
          }
        },
        form: this.$form.createForm(this),
        loading: false,
        // data: [{ 1: 1, 2: 2, 3: 3 }],
        data: [],
        show: false,
        orderNo: '',
        invoiceTime: '',
        status: ''
      }
    },
    methods: {
      moment,
      getCurrentData() {
        return new Date().toLocaleDateString()
      },
      newMember() {
        const newData = [...this.data]
        const length = this.data.length
        this.data.push({
          key: length === 0 ? '1' : (parseInt(this.data[length - 1].key) + 1).toString(),
          id: null,
          no: null,
          shelves: null,
          type: null,
          xyz: null,
          available: true
        })
      },

      remove(record) {
        if (record.id !== null && record.id !== '') {
          const args = new Map()
          args.set('id', record.detailId)
          return deleteOne('saleDetailDeleter', validateFields(args))
            .then(body => {
              if (body === '') {
                this.$message.success(this.$t('message.deleteSuccess'))
                this.data = this.data.filter(item => item.key !== record.key)
              } else {
                alert(body.message)
              }
            })
        } else {
          this.data = this.data.filter(item => item.key !== record.key)
        }
      }
    }

  }
</script>

<style scoped>

</style>